import { PlatformSpecificationEditor } from '@synthroneApp/components/forms/platform-specification-editor/platform-specification-editor.component';
import { Component, Inject, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Router, ActivatedRoute } from '@angular/router';
import { PlatformModel } from '@synthroneApp/models/platform/platform.model';
import { ApiService } from '@angular/synthrone-design/services';
import { APP_CONFIG } from '@synthroneApp/app.config';
import { MatDialog } from '@angular/material';
import { ErrorComponent } from '@angular/synthrone-design/components';
import { FormControl } from '@angular/forms';
import { ClientServiceSDK } from 'ms-client-angular-sdk';
import { LanguageServiceSDK, CountryServiceSDK } from 'ms-language-country-angular-sdk';

@Component({
  selector: 'platform-add-view',
  templateUrl: './platform-add-view.component.html',
  styleUrls: ['./platform-add-view.component.scss']
})


export class PlatformAddViewComponent implements OnInit {

  isDataLoading: number = 0;
  platformSlug: any;
  actionName: string;
  public platform: PlatformModel;
  clients: any[];
  clientsFiltered: any[];
  pipelines: any;
  parents: any[];
  specificationParseErrors = {
    pdpd: true,
    elp: true
  };
  defaultPipeline: number = 0;
  defaultAutomationPipeline: number = 0;
  countries: any[];
  countriesFiltered: any[];
  languages: any[];
  pipelineTypes: any[];
  storageTypes: any[];
  languagesFiltered: any[];
  internal: boolean = false;
  customComponents: boolean = false;
  notLive: boolean = false;


  public countryFilterCtrl: FormControl = new FormControl();
  public languageFilterCtrl: FormControl = new FormControl();
  public clientFilterCtrl: FormControl = new FormControl();

  constructor(
    private router: Router, 
    private route: ActivatedRoute, 
    protected api: ApiService, 
    @Inject(APP_CONFIG) private config, 
    protected dialog: MatDialog, 
    private clientService: ClientServiceSDK,
    private languagesService: LanguageServiceSDK,
    private countryService: CountryServiceSDK
    ) {
    this.actionName = (this.router.url.includes('add') ? 'Add' : 'Edit');
  }

  ngOnInit() {
    this.platform = {
      name: '',
      url: '',
      specification: '',
      elpSpecification: '',
      type: 'platform',
      storage: 'temporary'
    };

    this.countryFilterCtrl.valueChanges
      .subscribe((countryFilter) => {
        this.countriesFiltered = this.countries.filter(c => c.name.toLowerCase().trim().indexOf(countryFilter.toLowerCase().trim()) > -1 || c.isoAlpha2Code.toLowerCase().trim().indexOf(countryFilter.toLowerCase().trim()) > -1)
      });
    this.languageFilterCtrl.valueChanges
      .subscribe((languageFilter) => {
        this.languagesFiltered = this.languages.filter(l => l.name.toLowerCase().trim().indexOf(languageFilter.toLowerCase().trim()) > -1 || l.isoCode.toLowerCase().trim().indexOf(languageFilter.toLowerCase().trim()) > -1)
      });
    this.clientFilterCtrl.valueChanges
      .subscribe((clientFilter) => {
        this.clientsFiltered = this.clients.filter(c => c.name.toLowerCase().trim().indexOf(clientFilter.toLowerCase().trim()) > -1 || c.planet.toLowerCase().trim().indexOf(clientFilter.toLowerCase().trim()) > -1)
      });

    this.clients = [];
    this.pipelines = {};
    this.pipelineTypes = [
      {
        label: 'Platform',
        value: 'platform'
      },
      {
        label: 'Group',
        value: 'group'
      }
    ];

    this.storageTypes = [
      {
        label: 'Temporary',
        value: 'temporary'
      },
      {
        label: 'Permanent',
        value: 'permanent'
      }
    ];

    this.isDataLoading++;
    this.api.makeRequest('api_pipeline_system_list', {}, 'publisher').subscribe(
      (result) => {
        this.isDataLoading--;
        result['data'].forEach((pipeline) => {
          this.pipelines[pipeline.id] = pipeline;
        });
      },
      (error) => {
        this.isDataLoading--;
        let dialogRef = this.dialog.open(ErrorComponent, {
          data: {
            message: error
          }
        }).afterClosed().subscribe(result => {
          this.router.navigate(['/platforms']);
        });
      });

    this.isDataLoading++;
    this.api.makeRequest('api_platform_list', {'type': 'group'}, 'publisher').subscribe(
      (result) => {
        this.isDataLoading--;
        this.parents = result['data'];
        if (this.actionName === 'Edit') {
          this.platformSlug = this.router.url.substr(this.router.url.lastIndexOf('/') + 1);
          this.parents = this.parents.filter((el) => { return el.slug !== this.platformSlug });
        }
      },
      (error) => {
        this.isDataLoading--;
        let dialogRef = this.dialog.open(ErrorComponent, {
          data: {
            message: error
          }
        }).afterClosed().subscribe(result => {
          this.router.navigate(['/platforms']);
        });
      });

    this.isDataLoading++;
    this.clientService.clientsGet().subscribe(  
      (result) => {
        this.isDataLoading--;
        this.clients = result.sort((a, b) => {
          return a.name.localeCompare(b.name, 'en', { sensitivity: 'base' })
        });
        this.clientsFiltered = [...this.clients];
      },
      (error) => {
        this.isDataLoading--;
        let dialogRef = this.dialog.open(ErrorComponent, {
          data: {
            message: error
          }
        }).afterClosed().subscribe(result => {
          this.router.navigate(['/platforms']);
        });
      });

    this.isDataLoading++;

    this.countryService.countryGet().subscribe(
      (result) => {
        this.isDataLoading--;
        this.countries = result.sort((a, b) => {
          return a.name.localeCompare(b.name, 'en', { sensitivity: 'base' })
        })
        this.countriesFiltered = [...this.countries];
      },
      (error) => {
        this.isDataLoading--;
        let dialogRef = this.dialog.open(ErrorComponent, {
          data: {
            message: error
          }
        }).afterClosed().subscribe(result => {
          this.router.navigate(['/platforms']);
        });
      });

    this.isDataLoading++;
    this.languagesService.languageGet().subscribe(
      (languages) => {
        this.isDataLoading--;
        this.languages = languages;
        this.languages.sort((a: { name: string; }, b: { name: string; }) => a.name.toLowerCase().localeCompare(b.name.toLowerCase(), 'en', { sensitivity: 'base' }));
        this.languagesFiltered = [...this.languages];
      }, 
      (error) => {
        this.isDataLoading--;
        let dialogRef = this.dialog.open(ErrorComponent, {
          data: {
            message: error
          }
      }).afterClosed().subscribe(result => {
        this.router.navigate(['/platforms']);
      });
    });


    if (this.actionName == "Edit") {
      this.platformSlug = this.router.url.substr(this.router.url.lastIndexOf('/') + 1);
      this.isDataLoading++;
      this.api.makeRequest('api_system_platform_get', {
        slug: this.platformSlug
      }, 'publisher').subscribe(
        (result) => {
          this.isDataLoading--;
          let clientIds = [];
          Object.keys(result['clients']).forEach((key, index) => {
            clientIds.push(result['clients'][key]['planet'])
          });

          let pipelineIds = [];
          Object.keys(result['platform_pipelines']).forEach((key, index) => {
            pipelineIds.push(result['platform_pipelines'][key]['pipeline']['id']);
            if (result['platform_pipelines'][key]['default']) {
              this.defaultPipeline = result['platform_pipelines'][key]['pipeline']['id'];
            }
            if (result['platform_pipelines'][key]['default_automation']) {
              this.defaultAutomationPipeline = result['platform_pipelines'][key]['pipeline']['id'];
            }
          });

          this.platform = {
            id: result['id'],
            name: result['name'],
            url: result['url'],
            country: result['country'],
            language: result['language'],
            specification: JSON.stringify(result['specification']),
            elpSpecification: JSON.stringify(result['elpSpecification']),
            clients: clientIds,
            pipelines: pipelineIds,
            internal: result['internal'],
            customComponents: result['custom_components'],
            notLive: result['not_live'],
            type: result['type'].toString(),
            storage: result['storage'],
            parent: (result['parent']) ? result['parent']['id'] : null,
            eretailerCode: (result['eretailer_code']) ? result['eretailer_code'] : null
          };

          this.specificationParseErrors = {
            pdpd: false,
            elp: false
          };
        },
        (error) => {
          let dialogRef = this.dialog.open(ErrorComponent, {
            data: {
              message: error
            }
          }).afterClosed().subscribe(result => {
            this.router.navigate(['/platforms']);
          });
        });
    }
  }

  breadcrumbsFN = () => {
    return Observable.of([
      {
        breadcrumb: 'ADMINER',
        url: '/'
      },
      {
        breadcrumb: 'Manage platforms',
        url: '/platforms'
      },
      {
        breadcrumb: this.actionName + ' Platform',
        url: this.router.url
      }
    ]);
  };

  createPlatformFN = () => {
    let params = Object.assign({}, this.platform);

    delete params.pipelines;
    this.isDataLoading++;
    this.api.makeRequest('api_platform_add', params, 'publisher').subscribe(
      (result) => {
        this.isDataLoading--;
        this.platformSlug = result['slug'];
        this.submitPipelinesFN();
      },
      (error) => {
        this.isDataLoading--;
        let dialogRef = this.dialog.open(ErrorComponent, {
          data: {
            message: error
          }
        });
        this.platform.specification = JSON.stringify(this.platform.specification);
        this.platform.elpSpecification = JSON.stringify(this.platform.elpSpecification);
      });
  };

  editPlatformFN = () => {
    this.isDataLoading++;
    this.platform.slug = this.platformSlug;
    let params = Object.assign({}, this.platform);
    delete params.pipelines;
    if (!params.internal) {
      delete params.internal;
    }
    if (!params.customComponents) {
      delete params.customComponents;
    }
    if (!params.notLive) {
      delete params.notLive;
    }
    this.api.makeRequest('api_platform_update', params, 'publisher').subscribe(
      (result: any) => {
        this.platformSlug = result;
        this.submitPipelinesFN();
        this.isDataLoading--;
      },
      (error) => {
        this.isDataLoading--;
        let dialogRef = this.dialog.open(ErrorComponent, {
          data: {
            message: error
          }
        });
        this.platform.specification = JSON.stringify(this.platform.specification);
        this.platform.elpSpecification = JSON.stringify(this.platform.elpSpecification);
      });
  };

  submitPipelinesFN = () => {
    this.isDataLoading++;
    let params = {
      'platformSlug': this.platformSlug,
      'pipelines': []
    };

    if (this.platform.pipelines) {
      for (let i = 0; i < this.platform.pipelines.length; i++) {
        params['pipelines'][i] = {
          'pipeline': ''
        };
        params['pipelines'][i]['pipeline'] = this.platform.pipelines[i];
        if (this.platform.pipelines[i] === this.defaultPipeline) {
          params['pipelines'][i]['default'] = true;
        }
        if (this.platform.pipelines[i] === this.defaultAutomationPipeline) {
          params['pipelines'][i]['defaultAutomation'] = true;
        }
      }

      this.api.makeRequest('api_platform_assign_pipeline', params, 'publisher').subscribe(
        (result) => {
          this.isDataLoading--;
          this.router.navigate(['/platforms']);
        },
        (error) => {
          this.isDataLoading--;
          let dialogRef = this.dialog.open(ErrorComponent, {
            data: {
              message: error
            }
          });
        });
    } else {
      this.isDataLoading--;
      this.router.navigate(['/platforms']);
    }
  };

  submitFN(isValid: boolean) {
    this.isDataLoading++;
    this.isSpecificationValid('pdpd');
    this.isSpecificationValid('elp');
    if (this.platform.specification) {
      this.platform.specification = JSON.parse(this.platform.specification);
    }
    if (this.platform.elpSpecification) {
      this.platform.elpSpecification = JSON.parse(this.platform.elpSpecification);
    }
    if (this.actionName == 'Add') {
      this.createPlatformFN();
    } else {
      this.editPlatformFN();
    }
  }

  isSpecificationValid(specType) {
    if (specType === 'pdpd') {
      if (this.platform.specification) {
        if (this.isJsonString(this.platform.specification)) {
          this.specificationParseErrors.pdpd = false;
        } else {
          this.specificationParseErrors.pdpd = true;
        }
      } else {
        this.specificationParseErrors.pdpd = false;
      }
    } else {
      if (this.platform.elpSpecification) {
        if (this.isJsonString(this.platform.elpSpecification)) {
          this.specificationParseErrors.elp = false;
        } else {
          this.specificationParseErrors.elp = true;
        }
      } else {
        this.specificationParseErrors.elp = false;
      }
    }
  }

  specificationEditor = (e, specType) => {
    e.preventDefault();
    const specificationByType = (specType === 'pdpd') ? this.platform.specification : this.platform.elpSpecification;
    this.isSpecificationValid(specType);
    let data = specificationByType;
    if (this.specificationParseErrors[specType] || specificationByType.trim() == "") {
      data = '[]';
    }
    const dialogRef = this.dialog.open(PlatformSpecificationEditor, {
      data: data
    }).afterClosed().subscribe(result => {
      if (result) {
        if (specType === 'pdpd') {
          this.platform.specification = result;
        } else {
          this.platform.elpSpecification = result;
        }
      }
    });
  };

  isJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  checkParent() {
    if (this.platform.type === 'group') {
      this.platform.parent = null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/views/platform-add-view/platform-add-view.component.ts